import { SubmissionError } from 'redux-form'
import i18next from 'i18next'

import { formatApiValidationErrors } from './Errors'

export const generateSubmissionError = (e: any) => {
  if (e instanceof SubmissionError) {
    return e
  }

  let formErrors = {}

  if (e?.response?.data?.ValidationErrors) {
    formErrors = formatApiValidationErrors(e.response.data.ValidationErrors)
  }

  return new SubmissionError({
    _error: e?.response?.data?.Error || i18next.t('global.form_errors_found'),
    rejections: e?.response?.data?.Data?.Rejections,
    warnings: e?.response?.data?.Data?.Warnings,
    ...formErrors
  })
}
